/**
 *
 * Asynchronously loads the component for IncidentResponse
 *
 */

import { lazy } from 'react';

export const IncidentResponse = lazy(() =>
  import('./index').then(m => ({ default: m.IncidentResponse })),
);
